<template>
  <Container as="section" data-component="TextBlock">
    <Grid class="gap-y-6 lg:gap-y-8">
      <RichText
        v-if="isUmbracoRichText(header)"
        body-variant="header-2"
        class="col-start-1 col-end-13 lg:col-start-3 lg:col-end-11"
        :text="header" />
      <RichText
        v-if="isUmbracoRichText(body)"
        class="col-start-1 col-end-13 lg:col-start-3 lg:col-end-11"
        :text="body" />
    </Grid>
  </Container>
</template>

<script setup lang="ts">
import type { TextBlockGridApiModel } from '@gro-up/api/corporate'
import { Container, Grid, RichText } from '@gro-up/ui/primitives'
import { isUmbracoRichText } from '@gro-up/ui/utils'

type TextBlockProps = TextBlockGridApiModel

defineProps<TextBlockProps>()
</script>
